module.exports = __webpack_public_path__ + "img/a1.2b053aca.jpg";